import ErrorMessageToast from "src/components/ErrorMessageToast/ErrorMessageToast";
import MarqueeLiveTitle from "src/components/elements/MarqueeLiveTitle/MarqueeLiveTitle";
import styles from "src/components/layout/EventCardSmall/eventCardSmall.module.css";
import EventCardMenuModal from "src/features/Event/components/EventCardMenuModal/EventCardMenuModal";
import imageLoadErrorHandler from "src/utils/imageLoadErrorHandler";
import EventLikesIcon from "src/assets/icon/event_likes_icon.svg";
import { IoPersonSharp } from "react-icons/io5";
import CertificationMark from "src/components/elements/CertificationMark/CertificationMark";
import { useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import toggleEventLikes from "src/utils/toggleEventLikes";
import getCurrentUserId from "src/utils/currentUserId";
import Dialog from "../Dialog/Dialog";

type EventCardSmallProps = {
    handleCardClicked: () => void;
    setOperatedLikesList: (
        eventId: number,
        isLikes: boolean,
        likeCount: number
    ) => void;
    handleMenuButton: () => void;
    event: {
        event_id: number;
        title: string;
        place: string;
        thumbnail: string;
        eventType: string;
    };
    eventDayTime: string;
    user: {
        userId: number;
        username: string;
        userIconPath: string;
        certification: string;
    };
    isLiked: boolean;
    isLikesCount: number;
    isModalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    noShadow?: boolean;
    noLikes?: boolean;
};

const EventCardSmall: React.FC<EventCardSmallProps> = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    const currentUserId = getCurrentUserId();

    const handleLikes = (
        eventTarget: React.MouseEvent | React.KeyboardEvent
    ) => {
        eventTarget.stopPropagation();

        if (!currentUserId) {
            setIsModalOpen(true);
            return;
        }

        try {
            toggleEventLikes(
                props.event.event_id,
                props.isLikesCount,
                props.setOperatedLikesList
            );
        } catch (error: any) {
            toast.error(error.message);
        }
    };

    return (
        <>
            <div
                className={`${styles.small_event_card_container} ${
                    props.noShadow ? styles.no_shadow : ""
                }`}
                onClick={props.handleCardClicked}
                onKeyDown={props.handleCardClicked}
                role="link"
                tabIndex={0}
            >
                <div className={styles.small_event_card_img}>
                    <img
                        src={props.event.thumbnail}
                        alt=""
                        decoding="async"
                        loading="lazy"
                        onError={(e) => {
                            return imageLoadErrorHandler(e, "thumbnail");
                        }}
                    />
                    {/* いいね */}
                    {(!props.noLikes || currentUserId) && (
                        <div
                            className={styles.like_button_container}
                            onClick={(eventTarget) => {
                                return handleLikes(eventTarget);
                            }}
                            onKeyDown={(eventTarget) => {
                                return handleLikes(eventTarget);
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <div
                                className={`${
                                    styles.like_button_icon_container
                                } ${props.isLiked ? styles.liked : ""}`}
                            >
                                <img
                                    className={styles.like_button_icon}
                                    src={EventLikesIcon}
                                    alt=""
                                    decoding="async"
                                    loading="lazy"
                                />
                            </div>
                            <p className={styles.like_button_text}>
                                {props.isLikesCount}
                            </p>
                        </div>
                    )}
                </div>
                <div className={styles.small_event_card_information_container}>
                    <div className={styles.day_and_menu_container}>
                        <p className={styles.day_text}>{props.eventDayTime}</p>
                        <div
                            className={styles.menu_button_container}
                            onClick={(e) => {
                                e.stopPropagation();
                                props.handleMenuButton();
                            }}
                            onKeyDown={(e) => {
                                e.stopPropagation();
                                props.handleMenuButton();
                            }}
                            role="button"
                            tabIndex={0}
                            aria-label="イベントメニューを開く"
                        >
                            <div className={styles.menu_button_icon} />
                        </div>
                    </div>
                    <div className={styles.event_title_container}>
                        <MarqueeLiveTitle
                            liveTitle={props.event.title}
                            limit={9}
                        />
                    </div>
                    <div className={styles.event_place_container}>
                        <div className={styles.pin_container}>
                            <div className={styles.pin} />
                        </div>
                        <p className={styles.place_text}>{props.event.place}</p>
                    </div>
                    <div className={styles.name_container}>
                        <div className={styles.icon}>
                            <IoPersonSharp color="#747688" size="1.5rem" />
                        </div>
                        <div className={styles.name}>
                            <p>{props.user.username}</p>
                            {props.user.certification === "kobe_certified" && (
                                <div className={styles.certification_icon}>
                                    <CertificationMark />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                isOpen={isModalOpen}
                title="ログインしてください"
                content={
                    <>
                        <p>いいね機能を利用するにはログインが必要です。</p>
                        <br />
                        <p>
                            いいねをすると、いいねしたイベントをプロフィールページで確認することができます。
                        </p>
                    </>
                }
                onYes={{
                    label: "ログインする",
                    onClick: () => {
                        navigate("/login");
                    },
                }}
                onNo={{
                    label: "閉じる",
                    onClick: () => {
                        return setIsModalOpen(false);
                    },
                }}
                handleClose={() => {
                    return setIsModalOpen(false);
                }}
            />
            <EventCardMenuModal
                isModalOpen={props.isModalOpen}
                setIsModalOpen={props.setModalOpen}
                event={{
                    userId: props.user.userId,
                    id: props.event.event_id,
                    title: props.event.title,
                    place: props.event.place,
                    name: props.user.username,
                    eventType: props.event.eventType,
                }}
            />
            <ErrorMessageToast />
        </>
    );
};

export default EventCardSmall;
